import {
  MenuItem,
  Menu,
  Button,
  Stack,
  IconButton,
  Drawer,
  CircularProgress,
  Autocomplete,
  TextField,
  Chip, Box, InputBase,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { IoIosSearch } from "react-icons/io";

import { useState, useMemo, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate, useLocation } from "react-router-dom";
import SearchSidebar from "../sideBar";
import { callApi } from "../../generic/callApi";
import debounce from "lodash/debounce";
import { motion } from "framer-motion";
import { useCity } from "../../hooks/cityContext";
import { BsJustify } from "react-icons/bs";
const SearchContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isHomePage",
})(({ theme, isHomePage }) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  minWidth: 0,
  minHeight: 62,
  padding: "7px 8px 7px 16px",
  gap: 10,
  backgroundColor: "#FFFFFF",

  // Apply only on the home page
  border: isHomePage ? "1px solid #E8E8EC" : "none",
  borderRadius: isHomePage ? 16 : 0,
  boxShadow: isHomePage
    ? "0 5px 22px rgba(20, 20, 40, 0.07)"
    : "none",

  transition: "border-color 180ms ease, box-shadow 180ms ease",

  "&:focus-within": isHomePage
    ? {
        borderColor: alpha("#ED213A", 0.55),
        boxShadow: `0 0 0 3px ${alpha("#ED213A", 0.08)}`,
      }
    : {},

  [theme.breakpoints.down("sm")]: {
    minHeight: 52,
    padding: "5px 6px 5px 12px",
    gap: 7,
    borderRadius: isHomePage ? 13 : 0,
  },
}));

const rotatingPlaceholders = [
  "Search by location",
  "Search by city",
  "Search by Project"
];

export default function SearchBar2({ isInsideDrawer = false, onSelectCities ,searchHandler,formData}) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { changeCity } = useCity();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
   const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(queryParams.get("purpose") || "Buy");
  const [options, setOptions] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
const isHomePage = location.pathname === "/";
  const [loading, setLoading] = useState(false);

  const open = Boolean(anchorEl);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prev) => (prev + 1) % rotatingPlaceholders.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleMenuItemClick = (value) => {
    setSelectedItem(value);
    handleClose();
  };

  const fetchSuggestions = async (value) => {
    if (!value.trim()) return;
    setLoading(true);
    try {
      const data = await callApi({
        method: "get",
        url: `/user/suggestions?query=${value}`,
      });
      const clean = Array.isArray(data)
        ? data.filter((item) => item && typeof item === "object" && item.label && item.type)
        : [];
      setOptions(clean);
    } catch (error) {
      console.error("Suggestion fetch error:", error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useMemo(() => debounce(fetchSuggestions, 300), []);

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  const handleSearch = (values) => {
    const params = new URLSearchParams();
    if (selectedItem) params.append("purpose", selectedItem);
    values.forEach((item) => {
      if (item.label) params.append("city", item.label);

    });

    navigate(`/search-results?${params.toString()}`);
  };

  const mobileFilterHandler = () => setFilterDrawerOpen(true);
  const handleCloseFilterDrawer = () => {
    setFilterDrawerOpen(false);
  };

  

  return (
    <Box sx={{height:"100%" ,width: "100%"  }}>
      <Stack direction="row" alignItems="center" sx={{  width: "100%", height: "100%", bgcolor: "white", boxShadow: { sx: 10, } }}>
<SearchContainer
  isHomePage={isHomePage}
  onClick={() => {
    if (isMobile && !filterDrawerOpen && !isInsideDrawer) {
      setFilterDrawerOpen(true);
    }
  }}
  sx={{
    cursor: isMobile && !isInsideDrawer ? "pointer" : "default",
    borderRadius: isHomePage ? 10 :10,
    boxShadow  : isHomePage ? 0 :3
  }}
>
            { isTablet && <IoIosSearch size={20}/>}

          {/* Dropdown Purpose Selector */}
 {         isTablet && <>
          <Button
            onClick={handleClick}
            variant="text"
            disableRipple
            endIcon={<IoIosArrowDown />}
            sx={{
              height: "100%",
              display: { xs: "none", sm: "flex" },
              px: 2,
              color: "black",
              textTransform: "none",
              borderRight: "1px solid #ccc",
              borderRadius: 0,
              bgcolor: "transparent",
              "&:hover": { bgcolor: "transparent" },
            }}
          >
            {selectedItem || "Choose"}
          </Button>

          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={() => handleMenuItemClick("Buy")}>Buy</MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("Rent/Lease")}>Rent/Lease</MenuItem>
            <MenuItem onClick={() => handleMenuItemClick("PG")}>PG</MenuItem>
          </Menu>
          </>}

          {/* Autocomplete Search */}
          <Box
            sx={{ flex: 1}}
          >

            <Autocomplete
              multiple
              disableCloseOnSelect
              fullWidth
              freeSolo={false}
              options={options}
              loading={loading}
              value={selectedOptions}
              popupIcon={null}
              onChange={(e, value) => {
                setSelectedOptions(value);
                if (onSelectCities) {
                  const selectedCities = value.map((item) => item.label);
                  onSelectCities(selectedCities); // ⬅️ Send selected city labels to parent
                }

                if (!isMobile && !isDesktop) {
                  handleSearch(value);
                }
              }}

              onInputChange={(e, value, reason) => {
                if (reason === "input") {
                  setSearchKeyword(value);
                  debouncedFetch(value);

                }
              }}

              groupBy={(option) => option.type}
              getOptionLabel={(option) => option.label}
              renderTags={(value, getTagProps) => {
                if (value.length === 0) return null;
                const first = value[0];
                const label =
                  value.length > 1
                    ? `${first.label} + ${value.length - 1}`
                    : first.label;
                return <Chip label={label} {...getTagProps({ index: 0 })} />;
              }}
              renderInput={(params) => (
                <Box sx={{ position: "relative", flex: 1 }}> 
                  <InputBase
                    {...params.InputProps}
                    inputRef={params.InputProps.ref}
                    inputProps={{
                      ...params.inputProps,
                      readOnly: isMobile && !isInsideDrawer
                    }}
                    sx={{
                      pl: 2,
                      width: "100%",
                      fontSize: "1rem",
                      cursor: isMobile && !isInsideDrawer ? "pointer" : "text",
                    }}
                  />
                  {!searchKeyword && selectedOptions.length === 0 && (
                    <Box
                      component={motion.div}
                      key={rotatingPlaceholders[placeholderIndex]}
                      initial={{ opacity: 0, y: 0 }}
                      animate={{ opacity: 0.6, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.5 }}
                      sx={{
                        position: "absolute",
                        left: 16,
                        top: "20%",
                        transform: "translateY(-50%)",
                        color: "gray",
                        pointerEvents: "none",
                        fontSize: "1rem",
                      }}
                    >
                  
                      {rotatingPlaceholders[placeholderIndex]}
                    </Box>
                  )}
                </Box>
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <strong>{option.label}</strong>
                  &nbsp;<em style={{ fontSize: 12, color: "#888" }}>({option.type})</em>
                </li>
              )}
            />
          </Box>


          {/* Search Icon Button */}
          <IconButton
            onClick={() => {
    if (isDesktop && location.pathname === "/") {
      console.log("selectedO ptions",selectedOptions)
      formData.city=selectedOptions?.[0]?.label
      searchHandler();   // ✅ JUST CALL
    } else {
    }
    handleSearch(selectedOptions);
  }}
            
            sx={{
              display: { xs: "none", sm: "flex" },
              m: 0.6,
              bgcolor: "primary.main",
              "&:hover": { bgcolor: "primary.main" },
            }}
          >
            <SearchIcon style={{ color: "white" }} />
          </IconButton>
        </SearchContainer>
      </Stack>

      {/* Mobile Filter Drawer */}
      <Drawer anchor="bottom" open={filterDrawerOpen} onClose={handleCloseFilterDrawer}>
        <SearchSidebar
          purpose={selectedItem}
          onCloseParentDrawer={handleCloseFilterDrawer}
          isTablet={isTablet}
          isMobile={isMobile}
        />
      </Drawer>
    </Box>
  );
}